import { Box, Button, InputAdornment, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import { doc, getDoc, setDoc, getFirestore } from "firebase/firestore";

export default function EditZones() {
  // based on the start of the search val filter the array of countries
  const [searchVal, setSearchVal] = useState('')
  // list of countries
  const countries = [
    'Select country*', 'Afghanistan', 'Aland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bangladesh', 'Barbados', 'Bahamas', 'Bahrain', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Indian Ocean Territory', 'British Virgin Islands', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo-Brazzaville', 'Congo-Kinshasa', 'Cook Islands', 'Costa Rica', 'Croatia', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'El Salvador', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Federated States of Micronesia', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Lands', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and McDonald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iraq', 'Ireland', 'Isle of Man', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine','Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn Islands', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russia', 'Rwanda', 'Saint Barthélemy', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent', 'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Korea', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Sweden', 'Swaziland', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Vietnam', 'Venezuela', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'
  ];
  const db = getFirestore()
  
  const setupCountries = async () => {
    // const countryMap = {};

    return (await getDoc(doc(db, "shipping_zones/zones"))).data()
    // countries.slice(1).forEach(country => {
      // countryMap[country] = 'N/A';
    // });
    // return countryMap;
  }
  
  useEffect(() => {
    let fun = async () => {
      const dbCountryMap = (await getDoc(doc(db, "shipping_zones/zones"))).data()

      const orderedDbCountryMap = Object.keys(dbCountryMap).sort().reduce(
        (obj, key) => { 
          obj[key] = dbCountryMap[key]; 
          return obj;
        }, 
        {}
      );

      setCountryMap(orderedDbCountryMap)
    }
    fun()
  }, [])


  const [countryMap, setCountryMap] = useState(setupCountries())
  console.log(countryMap)


  const handleChange = (e, country) => {
    let tempCountryMap = {...countryMap}
    tempCountryMap[country] = e.target.value
    setCountryMap(tempCountryMap);
  }

  const handleSave = async () => {

    await setDoc(doc(db, `shipping_zones`, "zones"), countryMap)
  }

  const options = { 
    'BP': 'Base Price', 
    'EU': 'Europe', 
    'WZ1': 'World Zone 1', 
    'WZ2' : 'World Zone 2', 
    'WZ3': 'World Zone 3',
    'N/A': 'N/A'
  }

  return (
    <Box sx={{marginX: '20px'}}>
      <Typography variant='h4' align='center' gutterBottom marginTop={1}>
        Zones
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: '10px' }}>
        <TextField
          name="productType"
          margin="dense"
          id="standard-select-product"
          placeholder="Filter Country"
          sx={{width: '320px'}}
          value={searchVal}
          onChange={e => setSearchVal(e.target.value)}
          InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            }}
        />
          <Button 
          startIcon={<SaveIcon />} 
          variant='contained' 
          sx={{height : '50px', mt: '10px'}}
          onClick={handleSave}
        >
          Save
        </Button>
      </Box>
      <Paper sx={{ width: '100%', mb: '20px' }}>
        <TableContainer>
          <Table aria-label="simple table">
            {/* Table head */}
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant='h5'>
                    Country
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant='h5'>
                    Zone
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            {/* Table body */}
            <TableBody>
                {
                  Object.keys(countryMap)
                    .filter(country => country.toLowerCase().startsWith(searchVal.toLowerCase()))
                    .map((country, idx) => (
                      <TableRow>
                        <TableCell variant='p' align='center' width={'100px'}>
                          {
                            country
                          }
                        </TableCell>
                        {
                          <TableCell align="right">
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={countryMap[country]}
                              onChange={(e) => {handleChange(e, country)}}
                              sx={{minWidth: '145px', textAlign: 'left'}}
                            >
                              {
                                Object.keys(options).map((key) => (
                                  <MenuItem value={key} >
                                    {options[key]}
                                  </MenuItem>
                                ))
                              }
                            </Select>
                          </TableCell>
                        }
                    </TableRow>
                  ))
                }
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Button 
        startIcon={<SaveIcon />} 
        fullWidth 
        variant='contained' 
        sx={{mb : '10px'}}
        onClick={handleSave}
      >
        Save
      </Button>
    </Box>
  )
}
